export var PRICING_FEE_TYPE = /* @__PURE__ */ ((PRICING_FEE_TYPE2) => {
  PRICING_FEE_TYPE2["PERCENTAGE"] = "percentage";
  PRICING_FEE_TYPE2["AMOUNT"] = "amount";
  PRICING_FEE_TYPE2["SURCHARGE"] = "surcharge";
  return PRICING_FEE_TYPE2;
})(PRICING_FEE_TYPE || {});
export var PRICING_PRODUCT = /* @__PURE__ */ ((PRICING_PRODUCT2) => {
  PRICING_PRODUCT2["PLATFORM"] = "platform";
  PRICING_PRODUCT2["TRANSACTION"] = "transaction";
  PRICING_PRODUCT2["MESSAGE"] = "message";
  PRICING_PRODUCT2["MESSAGE_CARRIER_FEE"] = "message_carrier_fee";
  PRICING_PRODUCT2["REFUND"] = "refund";
  PRICING_PRODUCT2["DISPUTE"] = "dispute";
  PRICING_PRODUCT2["PROCESSOR_FEE"] = "processor_surcharge";
  PRICING_PRODUCT2["CONVERSATION"] = "conversation";
  PRICING_PRODUCT2["MERCHANT_REFUND"] = "merchant_refund";
  PRICING_PRODUCT2["AI_SERVICE_FEE"] = "ai_service_fee";
  PRICING_PRODUCT2["MANUAL"] = "manual";
  return PRICING_PRODUCT2;
})(PRICING_PRODUCT || {});
export var PRICING_CUSTOMER_TYPE = /* @__PURE__ */ ((PRICING_CUSTOMER_TYPE2) => {
  PRICING_CUSTOMER_TYPE2["VAULTED"] = "vaulted";
  PRICING_CUSTOMER_TYPE2["UNVAULTED"] = "unvaulted";
  return PRICING_CUSTOMER_TYPE2;
})(PRICING_CUSTOMER_TYPE || {});
export var PRICING_PERIOD = /* @__PURE__ */ ((PRICING_PERIOD2) => {
  PRICING_PERIOD2["MONTHLY"] = "monthly";
  return PRICING_PERIOD2;
})(PRICING_PERIOD || {});
export var PRICING_PLAN_TYPE = /* @__PURE__ */ ((PRICING_PLAN_TYPE2) => {
  PRICING_PLAN_TYPE2["PRO"] = "pro";
  PRICING_PLAN_TYPE2["VOLUME"] = "volume";
  PRICING_PLAN_TYPE2["ORIGINAL"] = "original";
  return PRICING_PLAN_TYPE2;
})(PRICING_PLAN_TYPE || {});
